import type {RouteRecordRaw} from "vue-router";
import {EPermissao} from "@/core/type/permissao.type";

export const lancamentoRecorrenciaRoutes: RouteRecordRaw[] = [
    {
        path: "/lancamento-recorrencia",
        name: "lancamento-recorrencia",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_LANCAMENTOS_RECORRENTES},
        component: () => import("@/modules/lancamentoRecorrencia/pages/PageLancamentoRecorrencia.vue")
    },
];
